// Laundry Line Art Icons - SVG Components
import React from 'react';

// Men's Clothing Icon
export const MenClothingIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 8L24 12V20L20 18L12 24V56H52V24L44 18L40 20V12L32 8Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24 12C24 16.4183 27.5817 20 32 20C36.4183 20 40 16.4183 40 12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M28 28H36" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M28 36H36" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Women's Clothing Icon
export const WomenClothingIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 8L22 14L20 24L26 26L24 56H40L38 26L44 24L42 14L32 8Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M28 14C28 16.2091 29.7909 18 32 18C34.2091 18 36 16.2091 36 14" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M26 32H38" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="32" cy="44" r="2" fill={color}/>
  </svg>
);

// Kids Clothing Icon
export const KidsClothingIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 12L26 16V22L22 20L16 26V48H48V26L42 20L38 22V16L32 12Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="32" cy="16" r="4" stroke={color} strokeWidth="2"/>
    <path d="M28 32H36" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="26" cy="40" r="2" fill={color}/>
    <circle cx="38" cy="40" r="2" fill={color}/>
  </svg>
);

// Unisex Icon
export const UnisexIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 8L18 12V18L14 16L8 22V44H28V22L24 18V12L24 8Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M40 8L34 14L32 24L38 26L36 56H44L42 26L48 24L46 14L40 8Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Blankets & Linen Icon
export const BlanketsIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="16" width="48" height="36" rx="2" stroke={color} strokeWidth="2"/>
    <path d="M8 24H56" stroke={color} strokeWidth="2"/>
    <path d="M16 32H48" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 40H48" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M20 16V12C20 10.8954 20.8954 10 22 10H42C43.1046 10 44 10.8954 44 12V16" stroke={color} strokeWidth="2"/>
  </svg>
);

// Carpets & Furniture Icon
export const CarpetsIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="20" width="48" height="32" rx="2" stroke={color} strokeWidth="2"/>
    <path d="M16 28H48" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 36H48" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 44H48" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 20L4 12H60L56 20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="32" cy="36" r="6" stroke={color} strokeWidth="2"/>
  </svg>
);

// Shoes & Bags Icon
export const ShoesBagsIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Shoe */}
    <path d="M8 44C8 44 10 36 18 36C26 36 28 40 32 40C36 40 40 36 40 36V48H8V44Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 44H40" stroke={color} strokeWidth="2"/>
    {/* Bag */}
    <rect x="44" y="24" width="14" height="20" rx="2" stroke={color} strokeWidth="2"/>
    <path d="M48 24V18C48 15.7909 49.7909 14 52 14H54C55.1046 14 56 14.8954 56 16V24" stroke={color} strokeWidth="2"/>
    <path d="M48 32H54" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Default/Generic Laundry Icon
export const LaundryIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12" y="8" width="40" height="48" rx="4" stroke={color} strokeWidth="2"/>
    <circle cx="32" cy="36" r="12" stroke={color} strokeWidth="2"/>
    <circle cx="32" cy="36" r="6" stroke={color} strokeWidth="2"/>
    <circle cx="20" cy="16" r="2" fill={color}/>
    <circle cx="28" cy="16" r="2" fill={color}/>
    <circle cx="36" cy="16" r="2" fill={color}/>
    <path d="M12 22H52" stroke={color} strokeWidth="2"/>
  </svg>
);

// Iron/Pressing Icon
export const IronIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 40L8 48H56L48 28H20L12 40Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 28V20C20 17.7909 21.7909 16 24 16H32" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 44H48" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="36" cy="36" r="2" fill={color}/>
  </svg>
);

// Dry Clean Icon
export const DryCleanIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="20" stroke={color} strokeWidth="2"/>
    <path d="M32 16V12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M24 12H40" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <text x="32" y="38" textAnchor="middle" fill={color} fontSize="14" fontWeight="bold">P</text>
  </svg>
);

// Wash Icon
export const WashIcon = ({ className = "h-8 w-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 24C16 24 20 20 26 20C32 20 32 28 38 28C44 28 48 24 48 24" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 36C16 36 20 32 26 32C32 32 32 40 38 40C44 40 48 36 48 36" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 48C16 48 20 44 26 44C32 44 32 52 38 52C44 52 48 48 48 48" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Icon mapping for categories
const LAUNDRY_ICONS = {
  'male': MenClothingIcon,
  'men': MenClothingIcon,
  'female': WomenClothingIcon,
  'women': WomenClothingIcon,
  'kids': KidsClothingIcon,
  'children': KidsClothingIcon,
  'unisex': UnisexIcon,
  'blanket': BlanketsIcon,
  'blankets': BlanketsIcon,
  'linen': BlanketsIcon,
  'carpet': CarpetsIcon,
  'carpets': CarpetsIcon,
  'furniture': CarpetsIcon,
  'shoes': ShoesBagsIcon,
  'bags': ShoesBagsIcon,
  'shoes-bags': ShoesBagsIcon,
  'iron': IronIcon,
  'pressing': IronIcon,
  'dry-clean': DryCleanIcon,
  'dryclean': DryCleanIcon,
  'wash': WashIcon,
  'laundry': LaundryIcon,
  'default': LaundryIcon
};

// Get icon component by name
export const getCategoryIconComponent = (iconName) => {
  if (!iconName) return LaundryIcon;
  const normalizedName = iconName.toLowerCase().replace(/[_\s]/g, '-');
  return LAUNDRY_ICONS[normalizedName] || LaundryIcon;
};

// Export all icons
export default {
  MenClothingIcon,
  WomenClothingIcon,
  KidsClothingIcon,
  UnisexIcon,
  BlanketsIcon,
  CarpetsIcon,
  ShoesBagsIcon,
  LaundryIcon,
  IronIcon,
  DryCleanIcon,
  WashIcon,
  getCategoryIconComponent
};
